export default __webpack_public_path__ + "images/BA.531e75d.png";